export function translateDocumentType(traduzir: String) {
	if (traduzir === "client_contract") {
		return "Contratos de serviços";
	}
	if (traduzir === "client_adictive") {
		return "Aditivos de contratos";
	}

	if (traduzir === "client_documents" || traduzir === "client") {
		return "Outros";
	}

	return traduzir;
}
